/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import IndexedDB from 'src/services/indexeddb-service';

import {
  GENERAL_STORE_NAME as STORE_NAME,
  RELEASE_KEY
} from './generalStorageConstants';

import type { Release } from 'src/shared/types/release';

/**
 * The purpose of this storage is to be a generic, catch-all
 * key-value storage for all the bits and bobs
 * that didn't fit into the other, dedicated storages.
 */

export const saveReleaseInfo = async (releases: Release[]) => {
  await IndexedDB.set(STORE_NAME, RELEASE_KEY, releases);
};

export const getReleaseInfo = async (): Promise<Release[]> => {
  const emptyReleases: Release[] = [];
  try {
    return (await IndexedDB.get(STORE_NAME, RELEASE_KEY)) ?? emptyReleases;
  } catch {
    return emptyReleases;
  }
};
